import { render, staticRenderFns } from "./NotFoundMsg.vue?vue&type=template&id=0778edd0&"
import script from "./NotFoundMsg.vue?vue&type=script&lang=js&"
export * from "./NotFoundMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports